<template>
    <div class="task-breakdown-table">
      <h2>Task Breakdown</h2>
      <table>
        <thead>
          <tr class="bold-row">
            <th>User Name</th>
            <th>Role</th>
            <th>Department</th>
            <th>Site</th>
            <th>Total Task Count</th>
            <th>Total Hours</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item,index in userTable" :key="index" :class="{'bold-row':index == userTable.length-1}">
            <td>{{ item.user_name }}</td>
            <td>{{ item.role }}</td>
            <td>{{ item.department_name }}</td>
            <td>{{ item.site_name }}</td>
            <td>{{ item.total_task_count }}</td>
            <td>{{ item.total_minutes }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      userTable: {
        type: Array,
        required: true,
      },
    },
 
  };
  </script>
  
  <style scoped>
  .task-breakdown-table {
    margin: 20px;
    border-collapse: collapse;
    width: 100%;
  }
  
  .task-breakdown-table h2 {
    text-align: center;
    margin-bottom: 20px;
  }
  
  .task-breakdown-table table {
    width: 100%;
    border-collapse: collapse;
  }
  
  .task-breakdown-table th,
  .task-breakdown-table td {
    border: 1px solid #ddd;
    padding: 8px;
    text-align: center;
  }
  
  .task-breakdown-table th {
    background-color: #f2f2f2;
    color: black;
    padding-top: 12px;
    padding-bottom: 12px;
  }
  
  .task-breakdown-table tr:nth-child(even) {
    background-color: #f9f9f9;
  }
  
  .task-breakdown-table tr:hover {
    background-color: #ddd;
  }

  .bold-row {
  font-weight: bold;
}
  </style>